import React from 'react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';
import { CalendarIcon } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * Champ date Shadcn (Popover + Calendar).
 * Props:
 *  - value (string YYYY-MM-DD ou '')
 *  - onChange (string YYYY-MM-DD)
 *  - className (optionnel)
 *  - size: 'default' | 'sm' (taille du bouton)
 *  - placeholder (optionnel)
 *  - testId (optionnel)
 */
export default function DatePickerField({
  value,
  onChange,
  className,
  size = 'default',
  placeholder = 'Choisir une date',
  testId,
}) {
  const date = value ? new Date(value + 'T00:00:00') : undefined;

  const handleSelect = (selected) => {
    if (!selected) return onChange('');
    const y = selected.getFullYear();
    const m = String(selected.getMonth() + 1).padStart(2, '0');
    const d = String(selected.getDate()).padStart(2, '0');
    onChange(`${y}-${m}-${d}`);
  };

  const display = date
    ? date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : placeholder;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className={cn(
            'w-full justify-start text-left font-normal gap-2',
            !date && 'text-muted-foreground',
            size === 'sm' && 'h-8 text-xs px-2',
            className
          )}
        >
          <CalendarIcon className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
          {display}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} onSelect={handleSelect} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
